// 扩展业务
export default [
  {
    path: '/businessSignUp',
    name: 'businessSignUp',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/outPutConfig/businessSignUp.vue'], resolve)
    }
  },
  {
    path: '/trainSignIn',
    name: 'trainSignIn',
    meta: {
      requireAuth: true,
      keepAlive: true
    },
    component: (resolve) => {
      require(['@/views/outPutConfig/trainSignIn.vue'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/outPutConfig.js